import Vue from 'vue'
import VueRouter from 'vue-router'
import Homeindex from '@/views/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Homeindex,
    meta: { title: 'index' }
   
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})




export default router
